//components
import QdCard from '../card/card.js';
import QdFooter from '../footer/footer.js';
// Mixins 
import { AppsData } from '../../mixins/apps-data.js';
//Scss
import './apps-overview.scss';
// Template and media files
import template from './apps-overview.vhtml';
import logo from '../../../_img/logo.svg';

export default {
	template: template,
	components: {
		QdCard,
		QdFooter,
		logo,
	},
	mixins: [
		AppsData,
	],
	computed: {
		content: vm => vm.$store.state.apps.data,
	}
};



// WEBPACK FOOTER //
// ./assets/_js/components/apps-overview/apps-overview.js